export default "__VITE_ASSET__y0a82Ip$__"